<div class="mb-10" [ngClass]="defineView?'marginIncrease':''">
  <div class="defineFormHeader" >
    <div class="heading2">
      <a [routerLink]="['/dashboard']" class="backbutton" *ngIf="defineView">
        <fa-icon [icon]="backbtn" style="color: #009dd9"></fa-icon>
      </a>
      <span class="heading2" *ngIf="currentStepNo == 4">ACD Summary for </span
      >Change Request #{{ crNo }}&nbsp;<span class="statusTag" *ngIf="crStatus"
        >({{ crStatus }})</span
      >
      <div class="acdviewlink">
        <a id="link1" href="#/ACD/ViewRequest?CR={{ crNo }}" class="links"
          >View request details</a
        >
        <span *ngIf="currentStepNo == 4"> | </span>
        <span
          class="links"
          (click)="stepClick('search', 2, false, 'JobPlan')"
          *ngIf="currentStepNo == 4"
          >Back to Search</span
        >
      </div>
    </div>
    <div id="containerform" class="chv-wizard-container" *ngIf="defineView">
      <div class="chv-wizard-step active">
        <div id="Icon1" class="chv-wizard-icon">1</div>
        <div id="Label1" class="chv-wizard-label">Define Request</div>
        <div class="chv-wizard-sep"></div>
      </div>
      <div class="chv-wizard-step next">
        <div id="Icon2" class="chv-wizard-icon">2</div>
        <div id="Label2" class="chv-wizard-label">Search</div>
        <div class="chv-wizard-sep"></div>
      </div>
      <div class="chv-wizard-step next">
        <div id="Icon3" class="chv-wizard-icon">3</div>
        <div id="Label3" class="chv-wizard-label">Build</div>
        <div class="chv-wizard-sep"></div>
      </div>
      <div class="chv-wizard-step next">
        <div id="Icon4" class="chv-wizard-icon">4</div>
        <div id="Label4" class="chv-wizard-label">ACD Summary</div>
      </div>
    </div>

  <div id="containerform " class="chv-wizard-container" *ngIf="!defineView">
    <a id="define" class="Item1" (click)="stepClick('Define', 1)">
      <div
        class="chv-wizard-step"
        [ngClass]="{ active: defineView, past: !defineView }"
      >
        <fa-icon
          [icon]="iconPack.FaCheck"
          style="color: white"
          class="chv-wizard-icon"
          *ngIf="!defineView"
        ></fa-icon>
        <div id="Icon4" class="chv-wizard-icon" *ngIf="defineView">1</div>
        <div id="Label1" class="chv-wizard-label">Define Request</div>
        <div class="chv-wizard-sep"></div>
      </div>
    </a>
    <a id="search" (click)="stepClick('Search', 2)">
      <div class="chv-wizard-step"
           [ngClass]="{
           active: searchView && !buildData,
           past: (!searchView && currentStepNo>
        1)
        }"
        >
        <fa-icon [icon]="iconPack.FaCheck"
                 style="color: white"
                 class="chv-wizard-icon"
                 *ngIf="!searchView && currentStepNo > 1">
        </fa-icon>

        <div id="Icon4"
             class="chv-wizard-icon"
             *ngIf="searchView || currentStepNo == 1">
          2
        </div>

        <div id="Label2" class="chv-wizard-label">Search</div>
        <div class="chv-wizard-sep"></div>
      </div>
    </a>
    <div class="chv-wizard-step"
         [class.active]="buildView && !buildData"
         [class.past]="!buildView && currentStepNo > 1"
         [class.greyed-out]="buildData"
         (click)="stepClick('Build', 3)">

      <fa-icon [icon]="iconPack.FaCheck"
               class="chv-wizard-icon"
               *ngIf="!buildView && currentStepNo > 1 && !buildData">
      </fa-icon>

      <div class="chv-wizard-icon step-icon"
           *ngIf="buildView || currentStepNo == 1 || buildData">
        3
      </div>

      <div class="chv-wizard-label step-label">Build</div>
      <div class="chv-wizard-sep"></div>
    </div>

    <div class="chv-wizard-step"
         [class.active]="summaryView && !summaryData"
         [class.past]="!summaryView && currentStepNo > 1"
         [class.greyed-out]="summaryData"
         (click)="onSummaryClick()">
    <fa-icon [icon]="iconPack.FaCheck"
             class="chv-wizard-icon"
             *ngIf="!summaryView && currentStepNo > 1 && !summaryData">
    </fa-icon>
    <div class="chv-wizard-icon step-icon"
         *ngIf="summaryView || currentStepNo == 1 || summaryData"> 4 </div>
    <div class="chv-wizard-label step-label">ACD Summary</div>
    </div>
  </div>
</div>

</div>
